var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('div', {
    class: _vm.theme.contractStatus
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.left",
      value: (3),
      expression: "3",
      modifiers: {
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.right",
      value: (3),
      expression: "3",
      modifiers: {
        "right": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "white": ""
    }
  }, [_vm._v("\n                Идентификация пройдена\n            ")])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77c4b2b8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/contractStatus/ContractStatus.vue
// module id = 911
// module chunks = 0